import type {
  AuthorizationScope,
  ExcludedAuthorizationStore,
  StandaloneAuthResult,
} from 'services/api/admin';

export interface ShopeePartnerScopeResult {
  ok: boolean;
  succeededKeys: Set<string>;
  excluded: Map<string, ExcludedAuthorizationStore>;
  scope?: AuthorizationScope;
}

/** 同轮补授权累积成功店铺与排除清单；最新失败状态仍阻断完成，等待重试。 */
export function mergeShopeePartnerScopeResult(
  previous: ShopeePartnerScopeResult | undefined,
  result: StandaloneAuthResult | undefined,
  scope: AuthorizationScope | undefined,
): ShopeePartnerScopeResult {
  const entry: ShopeePartnerScopeResult = {
    ok: !!result?.isSuccess,
    succeededKeys: new Set(previous?.succeededKeys),
    excluded: new Map(previous?.excluded),
    scope: scope ?? previous?.scope,
  };
  if (result?.isSuccess) {
    const { allStoreIds, storeNames } = result;
    (allStoreIds?.length ? allStoreIds.map(String) : storeNames ?? []).forEach((key) =>
      entry.succeededKeys.add(key),
    );
  }
  scope?.excludedStores?.forEach((store) => {
    entry.excluded.set(store.externalStoreId ?? store.storeName, store);
  });
  return entry;
}
